import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { FILTERING_RULE_FRAGMENT_FOR_CREATE } from './fragment'
import { Data, Variables } from './types'

export const CREATE_FILTERING_RULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${FILTERING_RULE_FRAGMENT_FOR_CREATE}
  ${ERROR_FRAGMENT}

  mutation createFilteringRule($input: CreateFilteringRuleInput!) {
    createFilteringRule(input: $input) {
      filteringRule {
        ...FilteringRuleFragmentForCreate
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
